var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{on:{"page:afterin":_vm.pageMounted}},[_c('f7-block',{staticClass:"content"},[_c('div',[_vm._v("帳號登入中...")]),_c('f7-progressbar',{staticStyle:{"width":"80%"},attrs:{"infinite":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }